import {
  AiOutlineEye,
  AiOutlineHeart,
  AiOutlineMessage,
  AiOutlineCalendar,
} from "react-icons/ai";
import "../../styles/visualization/visualizationEngagement.css";
import { formatCount } from "../../utils/text.js";
import { useEffect, useState } from "react";
import { addLike, getLike, removeLike } from "../../services/like.service.js";
import { useLocation, useNavigate } from "react-router-dom";

const VisualizationEngagement = ({
  views,
  likes,
  commentsCount,
  publishedAt,
  publicationId,
  isLoggedIn,
  scrollToComments,
}) => {
  const [likesCount, setLikesCount] = useState(likes);
  const [isLoading, setIsLoading] = useState(false);
  const [isLikedByMe, setIsLikedByMe] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) return;

    let cancelled = false;

    const fetchLike = async () => {
      try {
        const like = await getLike(publicationId);
        if (!cancelled) {
          setIsLikedByMe(like.isLikedByMe);
        }
      } catch (e) {
        // silent fail is OK for phase 1
      }
    };

    fetchLike();

    return () => {
      cancelled = true;
    };
  }, [publicationId, isLoggedIn]);

  const openLoginHandler = () => {
    navigate("/login", { state: { from: location } });
  };

  const toggleLike = async () => {
    if (!isLoggedIn || isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      let likesData = isLikedByMe
        ? await removeLike(publicationId)
        : await addLike(publicationId);
      setLikesCount(likesData.likesCount);
      setIsLikedByMe((prev) => !prev);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <section className="viz-engagement">
      <div className="viz-engagement-left">
        <div className="viz-meta">
          <AiOutlineCalendar />
          <span>{new Date(publishedAt).toLocaleDateString()}</span>
        </div>
      </div>

      <div className="viz-engagement-right">
        <div className="viz-stat">
          <AiOutlineEye />
          <span>{formatCount(views)}</span>
        </div>

        <div className="viz-stat">
          <button
            type="button"
            onClick={isLoggedIn ? toggleLike : openLoginHandler}
            className="viz-engagement-button"
            disabled={isLoading}
          >
            <AiOutlineHeart color={isLikedByMe ? "red" : "inherit"} />
          </button>
          <span>{formatCount(likesCount)}</span>
        </div>

        <div className="viz-stat">
          <button
            type="button"
            onClick={scrollToComments}
            className="viz-engagement-button"
            disabled={isLoading}
          >
            <AiOutlineMessage />
          </button>
          <span>{formatCount(commentsCount)}</span>
        </div>
      </div>
    </section>
  );
};

export default VisualizationEngagement;
